import { KBDocument } from '../../types';
import { sleepAndHeadaches } from './sleepAndHeadaches';
import { stressAndDigestion } from './stressAndDigestion';
import { symptomTrackingBestPractices } from './symptomTrackingBestPractices';

// Drop new curated documents in this folder and add them here — no other app
// code needs to change. KnowledgeBaseService.seedIfEmpty() ingests this list
// once, on first run, if the knowledge base is empty.
export const knowledgeBaseDocuments: KBDocument[] = [
  sleepAndHeadaches,
  stressAndDigestion,
  symptomTrackingBestPractices
];
